import React from 'react'
import { motion } from 'framer-motion'
import { Wrench, Shield, Users, CheckCircle } from 'lucide-react'
import SEO from '../components/SEO'

const ManufacturingStaffing = () => {
  const positions = [
    'Production Workers',
    'Quality Control Inspectors',
    'Maintenance Technicians',
    'Plant Managers',
    'Safety Coordinators',
    'Industrial Engineers'
  ]

  return (
    <div>
      <SEO
        title="Manufacturing & Industrial Staffing Agency in Hyderabad | SV Manpower"
        description="Hire skilled production workers, quality control inspectors, plant managers, and technicians in Hyderabad. Reliable manufacturing staffing solutions."
        keywords="manufacturing staffing Hyderabad, industrial recruitment agency, hire production workers, plant managers recruitment, local factory helper agency Kukatpally"
        url="https://svmanpower.com/solutions/manufacturing-staffing"
      />
      <section className="relative text-white py-20 lg:pt-32 bg-cover bg-center bg-no-repeat hero-bg-position" style={{ backgroundImage: 'url(/hero.webp)' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/80 to-primary-800/80"></div>
        <div className="container-max relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Manufacturing Staffing</h1>
            <p className="text-xl md:text-2xl text-primary-100">Skilled manufacturing professionals for operational excellence</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-secondary-900 mb-6">Manufacturing Excellence</h2>
              <p className="text-secondary-600 mb-6">We provide skilled manufacturing professionals who understand safety protocols, quality standards, and operational efficiency.</p>
              <ul className="space-y-3">
                {positions.map((position, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-700">{position}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1565043589221-1d5d7c3e4e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Manufacturing Staffing" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ManufacturingStaffing
